var exports = {
  "k": "x31de4314--e0ff94--container",
};

module.exports = exports;
